module.exports = __webpack_public_path__ + "ipotechnyj_kalkulyator.0d79b95e92e1c93fc76b7a14ede70b7c.jpg";